
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Building, Users, Calendar, TrendingUp } from 'lucide-react';
import { Organization } from '@/types/auth';

interface OrganizationsStatsProps {
  organizations: Organization[];
}

export function OrganizationsStats({ organizations }: OrganizationsStatsProps) {
  const totalOrganizations = organizations.length;
  const totalTeamMembers = organizations.reduce((sum, org) => sum + org.max_team_members, 0);
  const recentOrganizations = organizations.filter(org => {
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);
    return new Date(org.created_at) > weekAgo;
  }).length;

  const stats = [
    {
      title: "Total Organizations",
      value: totalOrganizations,
      icon: Building,
      description: "Active organizations"
    },
    {
      title: "Team Members Capacity",
      value: totalTeamMembers,
      icon: Users,
      description: "Total capacity across all orgs"
    },
    {
      title: "Created This Week",
      value: recentOrganizations,
      icon: Calendar,
      description: "New organizations"
    },
    {
      title: "Average Team Size",
      value: totalOrganizations > 0 ? Math.round(totalTeamMembers / totalOrganizations) : 0,
      icon: TrendingUp,
      description: "Members per organization"
    }
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <Card key={stat.title}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{stat.title}</CardTitle>
            <stat.icon className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{stat.value}</div>
            <p className="text-xs text-muted-foreground">{stat.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
